module.exports = __webpack_public_path__ + "static/media/Alerta.81579bed.svg";